export default "__VITE_ASSET__DGL2PveD__"